import styled from 'styled-components';

export default styled.div`
  margin-top: 1rem;
  font-size: 0.9rem;
  font-weight: 500;
`;
